import React from 'react'
import styled from 'styled-components'
import uniqueId from 'lodash/fp/uniqueId'
import PhotoActions from './photo-actions'

interface HeaderActionsProps {
  actionsLeft?: React.ReactNode[]
  actionsRight?: React.ReactNode[]
  photoModel?: string
  hasDefault?: boolean
}

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.s16} ${({ theme }) => theme.space.s12};

  ${({ theme }) => theme.mediaQuery.phone} {
    flex-direction: column;
    row-gap: ${({ theme }) => theme.space.s8};
  }
`

const ActionsLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: ${({ theme }) => theme.space.s8};

  ${({ theme }) => theme.mediaQuery.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }

  ${({ theme }) => theme.mediaQuery.phone} {
    align-items: flex-start;
  }
`
const ActionsRight = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.space.s8};

  ${({ theme }) => theme.mediaQuery.tablet} {
    flex-direction: column;
    justify-content: flex-start;
  }

  ${({ theme }) => theme.mediaQuery.phone} {
    align-items: flex-start;
  }
`

export const HeaderActions = ({
  actionsLeft,
  actionsRight,
  photoModel,
  hasDefault,
  ...props
}: HeaderActionsProps) => (
  <ActionsWrapper {...props}>
    <ActionsLeft className="actions-left joyride--created-actions-left">
      {actionsLeft &&
        actionsLeft.map((action: React.ReactNode) => (
          <div key={uniqueId('action-')}>{action}</div>
        ))}
    </ActionsLeft>
    <ActionsRight className="actions-right joyride--created-actions-right">
      {actionsRight &&
        actionsRight.map((action: React.ReactNode) => (
          <div key={uniqueId('action-')}>{action}</div>
        ))}
      {photoModel && (
        <PhotoActions photoModel={photoModel} hasDefault={hasDefault} />
      )}
    </ActionsRight>
  </ActionsWrapper>
)
